import type { PageMetadata } from "@/config/routes";
import { siteConfig } from "@/config/site";

function upsertMeta(selector: string, attributes: Record<string, string>): void {
  let element = document.head.querySelector<HTMLMetaElement>(selector);
  if (!element) {
    element = document.createElement("meta");
    document.head.append(element);
  }
  for (const [name, value] of Object.entries(attributes)) element.setAttribute(name, value);
}

function upsertCanonical(url: string): void {
  let element = document.head.querySelector<HTMLLinkElement>('link[rel="canonical"]');
  if (!element) {
    element = document.createElement("link");
    element.rel = "canonical";
    document.head.append(element);
  }
  element.href = url;
}

export function syncDocumentMetadata(meta: PageMetadata): void {
  document.title = meta.title;
  upsertMeta('meta[name="description"]', { name: "description", content: meta.description });
  upsertMeta('meta[name="robots"]', {
    name: "robots",
    content: meta.indexable ? "index, follow" : "noindex, nofollow",
  });
  upsertMeta('meta[property="og:title"]', { property: "og:title", content: meta.title });
  upsertMeta('meta[property="og:description"]', {
    property: "og:description",
    content: meta.description,
  });
  upsertMeta('meta[property="og:url"]', { property: "og:url", content: meta.canonical });
  upsertMeta('meta[property="og:image"]', {
    property: "og:image",
    content: new URL(siteConfig.socialImage, siteConfig.siteUrl).toString(),
  });
  upsertCanonical(meta.canonical);
}
